import create from "zustand";

interface GeneralSliceState {
  language: string;
}

export const createGeneralSlice = () => ({
  language: "de",
});
